<template>
  <CrudList
    title="Sub Admin"
    storeName="User_enterprises"
    labelAddNew="Agregar"
    slot-scope="{ item }"
    sortable
    next-link="/admin/deleted_users"
    :breadcrumbs="[
      {
        text: 'Gestión de usuarios',
        disabled: false,
        href: '/admin/user_enterprises'
      },
      {
        text: 'Sub admin',
        disabled: false,
        href: '#'
      },
    ]"
    canSearch
  >
    <template v-slot:profile_picture="{ item }">
      <v-row align="center" justify="center">
        <v-col cols="12">
          <v-list-item-avatar v-if="item.profile_picture">
            <img :src="item.profile_picture" alt="" />
          </v-list-item-avatar>
        </v-col>
      </v-row>
    </template>
        <template v-slot:completed_name="{item}">
      {{ item.name || '' }} {{ item.last_name || ''}}
    </template>

  </CrudList>
</template>

<script>
import CrudList from "@/components/Crud/CrudList";

export default {
  components: { CrudList },
};
</script>
